import can from 'can';
import Component from 'can/component/component';
import template from './modal-dialog-new.stache';

const dialogModelNew = can.Map.extend({
    define: {
        isShown: {
            type: 'boolean',
            value: false,
        },
    },
    modalClosed: function() {
        this.dispatch('modalClosed');
    },
});

Component.extend({
    viewModel: dialogModelNew,
    template: template,
    leakScope: false,
    tag: 'modal-dialog-new',
    events: {
        '.js-modal-dialog click'($element, $event) {
            $event.stopPropagation();
        },
        '.js-modal-dialog__close click'() {
            this.viewModel.modalClosed();
        },
    },
});
